<div class='task-form' [formGroup]='taskForm()'>
  @for (parameter of task().inputParameters; track parameter.name) {
    <div class='task-form-inline-picker'>
      @if (parameter.type === 'URL') {
        <mat-form-field
          class='task-form-parameter-text'
          subscriptSizing='fixed'
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='url'
            [placeholder]='inputPlaceholder(parameter)'
            [required]='isRequired(parameter)'>
          @if (taskForm().controls[parameter.name]?.errors?.required) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              Required
            </mat-error>
          }
          @if (taskForm().controls[parameter.name]?.errors?.invalidValue) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              {{ taskForm().controls[parameter.name].errors.invalidValue }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (parameter.type === 'NUMBER') {
        <mat-form-field
          subscriptSizing='fixed'
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='number'
            [placeholder]='inputPlaceholder(parameter)'
            [required]='isRequired(parameter)'>
          @if (taskForm().controls[parameter.name]?.errors?.required) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              Required
            </mat-error>
          }
          @if (taskForm().controls[parameter.name]?.errors?.invalidValue) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              {{ taskForm().controls[parameter.name].errors.invalidValue }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (parameter.type === 'STRING') {
        <mat-form-field
          class='task-form-parameter-text'
          subscriptSizing='fixed'
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='text'
            [placeholder]='inputPlaceholder(parameter)'
            [required]='isRequired(parameter)'>
          @if (taskForm().controls[parameter.name]?.errors?.required) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              Required
            </mat-error>
          }
          @if (taskForm().controls[parameter.name]?.errors?.invalidValue) {
            <mat-error [attr.data-cy]="'task-parameter-error-' + parameter.displayName">
              {{ taskForm().controls[parameter.name].errors.invalidValue }}
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
  }
</div>
